import { render } from "./modal-chatbot-infos.vue?vue&type=template&id=6c0b45b2&scoped=true"
import script from "./modal-chatbot-infos.vue?vue&type=script&lang=js"
export * from "./modal-chatbot-infos.vue?vue&type=script&lang=js"

import "./modal-chatbot-infos.vue?vue&type=style&index=0&id=6c0b45b2&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0b45b2"],['__file',"src/components/modal-chatbot-infos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c0b45b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c0b45b2', __exports__)) {
    api.reload('6c0b45b2', __exports__)
  }
  
  module.hot.accept("./modal-chatbot-infos.vue?vue&type=template&id=6c0b45b2&scoped=true", () => {
    api.rerender('6c0b45b2', render)
  })

}


export default __exports__